import PropTypes from 'prop-types';
// next
import { useRouter } from 'next/router';
// @mui
import { TableRow, TableCell, Typography, Stack, Link } from '@mui/material';
// components
import Avatar from '../../components/Avatar';
import Label from '../../components/Label';
import Iconify from '../../components/Iconify';
// utils
import { fKrDateKST } from '../../utils/formatTime';
//
import { PATH_TODO } from '../../routes/paths';

// ----------------------------------------------------------------------

CompanyTableRow.propTypes = {
  row: PropTypes.object,
};

export default function CompanyTableRow({ row }) {
  const {
    id,
    name,
    is_active,
    contract_end_date,
  } = row;

  const getStatusColor = (isActive) => {
    return isActive ? 'info' : 'default';
  };

  const router = useRouter();

  const pushToCompany = () => {
    router.push({pathname: PATH_TODO.detail, query: {c: id}})
  }

  return (
    <TableRow>
      <TableCell align="left">
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="left">
          <Avatar
            src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/bji_${id%4 + 1}.png`}
            alt={name}
            sx={{
              width: 40,
              height: 40,
            }}
          />
          <Typography variant="subtitle1" noWrap>
            {name}
          </Typography>
        </Stack>
      </TableCell>

      <TableCell align="center">
        <Label color={getStatusColor(is_active)}>
          {is_active ? '계약 중' : '계약 종료'}
        </Label>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">
          {fKrDateKST(contract_end_date)}
        </Typography>
      </TableCell>

      <TableCell align="right">
        <Stack direction="row" spacing={.5} alignItems="center" justifyContent="right">
          <Link
            variant="subtitle2" onClick={pushToCompany} 
            underline="hover" color="text.secondary" noWrap
            sx={{ cursor: 'pointer' }}
          >
            자세히 보기
          </Link>
          <Iconify icon="eva:chevron-right-fill"
            sx={{ color: "text.secondary",
              ml: 0.5,
              width: 20,
              height: 20,
            }}
          />
        </Stack>
      </TableCell>
    </TableRow>
  )
}